import { useEffect, useState } from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";

import Login from "containers/Login";
import Logout from "pages/auth/Logout";
import AppPage from "containers/AppPage";
import ResetPassword from "containers/ResetPassword";
import ResetUserPassword from "pages/auth/ResetUserPassword";
import CognitoAuthentication from "pages/cognito/auth/CognitoAuthentication";

import { PublicRoute, ProtectedRoute } from "utils/routes.util";

const AppRoutes = ({ redirectPath }) => {
  const location = useLocation();
  const [appInstanceKey, setAppInstanceKey] = useState(0);

  useEffect(() => {
    if (location.state?.appResetAt) {
      setAppInstanceKey(location.state.appResetAt);
    }
  }, [location.state?.appResetAt]);

  return (
    <Routes>
      <Route path="/" element={<Navigate to={redirectPath} replace />} />

      <Route path="/login" element={<PublicRoute component={Login} />} />

      <Route
        path="/reset-password"
        element={<PublicRoute component={ResetUserPassword} />}
      />

      <Route
        path="/reset/:authToken"
        element={<PublicRoute component={ResetPassword} />}
      />

      <Route
        path="/auth/cognito"
        element={<PublicRoute component={CognitoAuthentication} />}
      />

      <Route path="/logout" element={<ProtectedRoute component={Logout} />} />

      <Route
        path="/*"
        element={<ProtectedRoute component={AppPage} key={appInstanceKey} />}
      />
    </Routes>
  );
};

export default AppRoutes;
